import React from 'react';

const plans = [
  {
    icon: '🪢',
    name: 'Essentiel',
    price: 'Gratuit',
    desc: 'Idéal pour les apprenants sociaux comme Demba',
    features: [
      'Ajout jusqu’à 50 relations',
      '1 seul tag par relation',
      'Pas de suggestions IA',
      'Pas de cartographie relationnelle',
      'Pas de rappel automatique',
      'Export des données limité',
    ],
    cta: 'Commencer gratuitement',
    color: 'border-blue-200',
    highlight: false,
  },
  {
    icon: '🛠️',
    name: 'Pro',
    price: '8,99 €/mois',
    priceYear: 'ou 89 €/an',
    desc: 'Pour les utilisateurs actifs et managers',
    features: [
      'Relations illimitées',
      'Tags multiples par contact',
      'Timeline d’événements relationnels',
      'Cartographie dynamique des cercles',
      'Notifications IA personnalisées',
      'Intégrations calendriers & CRM',
    ],
    cta: 'Essayer Pro',
    color: 'border-purple-400',
    highlight: true,
  },
  {
    icon: '🧠',
    name: 'Insight',
    price: '14,99 €/mois',
    priceYear: 'ou 149 €/an',
    desc: 'Pour un usage avancé, pro ou RH',
    features: [
      'Analyse d’impact relationnel (KPI soft skills)',
      'Suggestions IA comportementales',
      'Rapports exportables',
      'Suivi avancé (récurrence, tendances émotionnelles, etc.)',
    ],
    cta: 'Découvrir Insight',
    color: 'border-green-200',
    highlight: false,
  },
];

function PricingPage() {
  return (
    <section className="min-h-[80vh] bg-[#f7fafd] py-20 px-4 md:px-0 flex flex-col items-center">
      <div className="max-w-3xl w-full bg-white rounded-2xl shadow-xl p-8 animate-fadeIn mb-12">
        <h1 className="text-3xl font-bold text-blue-900 mb-4 text-center">🆓 Essai Premium 30 jours</h1>
        <p className="text-blue-700 text-center mb-6 leading-relaxed">Profitez de toutes les fonctionnalités premium pendant 30 jours, sans engagement.</p>
        <ul className="text-blue-800 text-sm mb-6 list-disc list-inside max-w-xl mx-auto space-y-3 leading-relaxed">
          <li>Création et visualisation de la cartographie relationnelle</li>
          <li>Ajout illimité de contacts, événements et tags</li>
          <li>Rappels intelligents & alertes relationnelles</li>
          <li>Suggestions IA (propositions d’interaction, relances, création de groupe)</li>
          <li>Accès aux statistiques de réseau personnel</li>
        </ul>
        <div className="bg-blue-50 rounded-lg p-5 text-blue-800 text-center text-xs leading-relaxed">
          À l’issue des 30 jours, passage automatique au plan « Essentiel » sauf souscription.
        </div>
      </div>
      <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {plans.map((plan) => (
          <div key={plan.name} className={`relative bg-white border-2 ${plan.color} rounded-2xl shadow p-8 flex flex-col items-center animate-fadeIn transition-transform duration-300 hover:scale-105 hover:shadow-xl ${plan.highlight ? 'ring-2 ring-purple-300' : ''}`}>
            {plan.highlight && (
              <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-500 to-blue-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg">Le plus populaire</span>
            )}
            <span className="text-4xl mb-2">{plan.icon}</span>
            <h2 className="text-xl font-bold text-blue-900 mb-1">{plan.name}</h2>
            <div className="text-blue-700 mb-2 font-semibold">{plan.price} {plan.priceYear && <span className="text-xs">{plan.priceYear}</span>}</div>
            <div className="text-blue-700 text-sm mb-2 text-center">{plan.desc}</div>
            <ul className="text-blue-800 text-sm mb-4 list-disc list-inside text-left">
              {plan.features.map((f) => <li key={f}>{f}</li>)}
            </ul>
            <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-2 rounded-lg shadow font-semibold hover:from-blue-600 hover:to-purple-600 transition w-full">{plan.cta}</button>
          </div>
        ))}
      </div>

      {/* Tableau comparatif */}
      <div className="max-w-5xl w-full bg-white rounded-2xl shadow-xl p-6 animate-fadeIn overflow-x-auto mt-8">
        <h2 className="text-xl font-bold text-blue-900 mb-6 text-center">Comparatif des fonctionnalités</h2>
        <table className="w-full text-sm text-blue-900 border-separate border-spacing-y-1">
          <thead>
            <tr className="bg-blue-50">
              <th className="p-3 text-center font-semibold">Fonctionnalité</th>
              <th className="p-3 text-center font-semibold">Essentiel</th>
              <th className="p-3 text-center font-semibold">Pro</th>
              <th className="p-3 text-center font-semibold">Insight</th>
            </tr>
          </thead>
          <tbody>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Relations illimitées<br /><span className="text-xs text-blue-400">(Essentiel : 50 max)</span></td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Tags multiples<br /><span className="text-xs text-blue-400">(Essentiel : 1 seul)</span></td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Cartographie relationnelle</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Suggestions IA</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅<br /><span className="text-xs text-blue-400">(avancées)</span></td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Rappels & alertes</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅<br /><span className="text-xs text-blue-400">(personnalisés)</span></td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Timeline d’événements</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Statistiques réseau</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅<br /><span className="text-xs text-blue-400">(KPI avancés)</span></td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Export des données</td>
              <td className="p-3 text-center">⏳<br /><span className="text-xs text-blue-400">Limité</span></td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Intégrations (Calendrier, CRM)</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Rapports exportables</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
            </tr>
            <tr className="even:bg-blue-50">
              <td className="p-3 text-center">Suivi avancé (KPI, émotions, etc.)</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">❌</td>
              <td className="p-3 text-center">✅</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default PricingPage; 